import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const KulinerPage = () => (
  <Layout>
    <SEO title="Aplikasi kuliner makanan minuman" />
    <div class="embed-responsive embed-responsive-16by9">
    <iframe title="aplikasi restoran cafe online" width="560" height="315" src="https://www.youtube.com/embed/5OPqg3jOo2k" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
    <div class="masthead-followup row m-0">
<div class="col-12 col-md-12 p-3 p-md-5 bg-white text-center">
   <h2>Boosterpos Resto</h2>
    <p><a href="/kuliner" title="aplikasi kuliner">Aplikasi kuliner</a> untuk usaha makanan dan minuman modern, aplikasi ini sangat mudah digunakan dengan simple system dalam pembuatan nya menggunakan <a href="https://www.apachefriends.org/" target="blank">XAMPP</a> dengan local server maupun clouds online host.</p>
    <img alt="aplikasi kasir online" class="img-fluid rounded shadow" src="./img/mesinkasirrrestorancafeonline.png"/>
    <p>Desain modern dengan user interface yang mudah dan simple via bahasa pemrograman <a href="https://www.php.net/" target="blank">PHP</a> semakin memudahkan dalam aktivitas pekerjaan , cocok digunakan untuk usaha kuliner seperti restoran cafe warkop angkringan toko oleh oleh toko jajan dan berbagai usaha kuliner lain maupun drink shop dan street food.</p>
    <img alt="aplikasi kasir online" class="img-fluid rounded shadow" width="100%" src="./img/mesinkasirrrestorancafeonline6 .png"/>
    <p>Semakin mudah dalam penjualan point of sale kasir dengan pencatatan nama pelanggan , nomor meja dan keterangan lain hingga mode pembayaran cash maupun online payment dalam aktivitas bertransaksi kasir.</p>
    <img alt="aplikasi kasir online" class="img-fluid rounded shadow" width="100%" src="./img/mesinkasirrrestorancafeonline10 .png"/>
    <p>Laporan laporan detail pada backoffice dashboard memudahkan aplikasi kuliner ini dalam kebutuhan cek dan monitoring pembukuan dengan mudah nya via <a href="https://www.mysql.com/" target="blank">mysql</a> databased lebih aman dan stabil.</p>
    <a href="./img/Boosterpos Resto App.pdf" class="button">Download</a> <a href="https://www.youtube.com/playlist?list=PLQDm6k9_HvYM7ayj4-xXcjqraOPXcSPER" target="blank" class="button button-outline">Demo</a>
</div>
<div class="col-12 col-md-12 p-3 p-md-5 bg-white border text-center">
  <h3>PRICE LIST</h3>
  <p>Daftar harga aplikasi kuliner offline dan online.</p>
</div>
<div class="col-12 col-md-4 p-3 p-md-5 bg-white text-center border">
<h3 class="bg-dark text-white p-3 md-5">Offline</h3><hr/>
<li>Full aplikasi boosterpos resto</li>
<li>Installation for one hardware</li>
<li>Ebook and Video Tutorial</li>
<li>Live Time Support</li><hr/>
<p>Rp.550.000</p>
<hr/>
<Link class="button" to="/harga">Order</Link>
</div>
<div class="col-12 col-md-4 p-3 p-md-5 bg-white text-center border">
<h3 class="bg-danger text-white p-3 md-5">Website</h3><hr/>
<li>Full aplikasi boosterpos resto</li>
<li>Installation clouds for one years</li>
<li>Free Landing page website</li>
<li>Free domain name .com</li>
<li>Free hosting</li>
<li>Accsess via you website</li>
<li>Ebook and Video Tutorial</li>
<li>Live Time Support</li><hr/>
<p>Rp.1.550.000</p>
<hr/>
<Link class="button" to="/web">Order</Link>
</div>
<div class="col-12 col-md-4 p-3 p-md-5 bg-white text-center border">
<h3 class="bg-info text-white p-3 md-5">Dbased On</h3><hr/>
<li>Full aplikasi boosterpos resto</li>
<li>Installation clouds for one years</li>
<li>Accsess via we website</li>
<li>Ebook and Video Tutorial</li>
<li>Live Time Support</li><hr/>
<p>Rp.550.000</p>
<hr/>
<Link class="button" to="/harga">Order</Link>
</div>
<div class="col-12 col-md-12 p-3 p-md-5 bg-white text-center border">
Setelah order aplikasi kamu bisa gunakan mesin kasir pos untuk menunjang kebutuhan bisnismu secara langsung.<br/><Link to="/mesinkasir">Pilih Mesin Kasir mu →</Link>
</div>
</div>
  </Layout>
)

export default KulinerPage
